// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3H4Ge","content":"Consent_content__16w7i","footer":"Consent_footer__2lzI0"};